import { styled } from '@mui/material/styles';

const StyledAlertMessage = styled('div')(
  ({ bgcolor, style, styleWrapper }) => ({
    display: 'flex',
    alignItems: 'center',
    background: bgcolor,
    borderRadius: '8px',
    padding: '8px',
    gap: '8px',
    justifyContent: 'space-between',
    '.content-wrapper': {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      ...styleWrapper,
    },
    wordBreak: 'break-word',
    ...style,
  }),
);

export { StyledAlertMessage };
